exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tax-configurations .no-select-option{color:var(--text-light)}#tax-configurations .no-value{font-style:italic}#tax-configuration-preview{position:relative}@keyframes flash{0%{background-color:var(--boy-blue-5);border-color:var(--boy-blue-5)}}#tax-configuration-preview.loading{animation:flash .4s ease-in-out forwards}", ""]);

// exports
